/**
 * Log Bot HTTP helpers.
 * Uses axiosClient so app-wide E2E encryption is applied automatically
 * (same pattern as campaign.services.js AI endpoints).
 * Base host: REACT_APP_BASE_URL_AI (exported as BASE_URL_AI).
 */
import { axiosClient, BASE_URL_AI } from "../../../../Constant/apiConstant";
import type { CallBrief, SessionSummary, StoredMessage } from "./logBotTypes";

const LOG_BOT_HTTP_BASE = `${BASE_URL_AI}/log_bot`;

export const getLogBotWsUrl = (): string => {
  const wsBase = String(BASE_URL_AI)
    .replace(/^https/, "wss")
    .replace(/^http(?!s)/, "ws");
  return `${wsBase}/log_bot/ws`;
};

export const fetchCallBrief = async (callUuid: string): Promise<CallBrief> => {
  try {
    const res = await axiosClient.get(`${LOG_BOT_HTTP_BASE}/call/${callUuid}`);
    const data = res?.data;
    return (data?.call ?? data) as CallBrief;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const fetchSessions = async (
  callUuid: string
): Promise<SessionSummary[]> => {
  try {
    const res = await axiosClient.get(`${LOG_BOT_HTTP_BASE}/sessions`, {
      params: { call_uuid: callUuid, limit: 50 },
    });
    return (res?.data?.sessions ?? []) as SessionSummary[];
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const fetchSessionMessages = async (
  sessionId: string,
  callUuid: string
): Promise<StoredMessage[]> => {
  try {
    const res = await axiosClient.get(
      `${LOG_BOT_HTTP_BASE}/sessions/${sessionId}/messages`,
      { params: { call_uuid: callUuid, limit: 0 } }
    );
    return (res?.data?.messages ?? []) as StoredMessage[];
  } catch (err) {
    console.log(err);
    throw err;
  }
};
